import { render, staticRenderFns } from "./ResaleTax.vue?vue&type=template&id=e0461166&scoped=true"
import script from "./ResaleTax.vue?vue&type=script&lang=js"
export * from "./ResaleTax.vue?vue&type=script&lang=js"
import style0 from "./ResaleTax.vue?vue&type=style&index=0&id=e0461166&prod&lang=scss&scoped=true"
import style1 from "./ResaleTax.vue?vue&type=style&index=1&id=e0461166&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0461166",
  null
  
)

export default component.exports